import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Archivos de traducción
import enTranslation from "./locales/en.json";
import esTranslation from "./locales/es.json";
import deTranslation from "./locales/de.json";
import itTranslation from "./locales/it.json";
import frTranslation from "./locales/fr.json";
import ptTranslation from "./locales/pt.json";
import zhTranslation from "./locales/zh.json";
import hiTranslation from "./locales/hi.json";

// Configuración de i18next
i18n
  .use(LanguageDetector) // Detecta el idioma del navegador
  .use(initReactI18next) // Integración con React
  .init({
    resources: {
      en: { translation: enTranslation },
      es: { translation: esTranslation },
      de: { translation: deTranslation },
      it: { translation: itTranslation },
      fr: { translation: frTranslation },
      pt: { translation: ptTranslation },
      zh: { translation: zhTranslation },
      hi: { translation: hiTranslation },
    },
    fallbackLng: "es", // Idioma por defecto
    debug: true,
    interpolation: {
      escapeValue: false, // React ya maneja la seguridad contra XSS
    },
  });

export default i18n;